$(document).ready(function(){
	$.fn.placeholder=function(){if(this[0]&&"placeholder"in document.createElement("input"))return;$("form").submit(function(){$("input[placeholder]").each(function(){if($(this).val()===$(this).attr("placeholder")){$(this).val("")}})});return this.live("focusin",function(){if($(this).val()===$(this).attr("placeholder")){$(this).val("");$(this).toggleClass("placeholder")}}).live("focusout",function(){if($(this).val()===""){$(this).val($(this).attr("placeholder"));$(this).toggleClass("placeholder")}}).focusout()};$("input[placeholder]").placeholder();
	$.expr[':'].hasData = function(obj, index, meta, stack) {return (undefined !== $(obj).data(meta[3]));};

	$("a.scrollTo").click(function(event){
		event.preventDefault();
		$('html,body').animate({scrollTop:$(this.hash).offset().top - 51}, 500);
	});

	var $slideshow = $('.cases').cycle({
		fx: 'fade',
		timeout: 12000,
		prev: '.prev',
		next: '.next',
		before: function(curr, next, opts) {

			var viewText = $('#SlideIndicator').data('init');
	        if (!viewText || opts.nextSlide == 0) {

				// Save initial text
				if (!viewText) {
					$('#SlideIndicator').data('init', $('#SlideIndicator').html());
				}
				else {
		        	$('#SlideIndicator').html(viewText);
				}

				return false;
			}

			// Update Slide Count if Not first Slide
			$('#SlideIndicator').html((opts.nextSlide) + ' / ' + (opts.slideCount - 1));
		}
	}).cycle('pause');


	// Play/Pause the Slideshow
	// -------------------------------------
	$('.play-pause').on("click", function(){

		$(this).toggleClass('play pause');

		if ($(this).hasClass('play')) {
			$slideshow.cycle('pause');
		} else {

			// If slideshow is on cover when this is clicked, advance to the next slide first
			if ($('.case:visible').prevUntil('.cases').length == 0 ) {
				$slideshow.cycle('next');
			}

			$slideshow.cycle('resume');
		}

	});


});